export const styles = {
  global: (props) => ({
    'html, body': {
      fontSize: '16px',
      lineHeight: 'base',
      bg: 'rgba(12, 19, 34, 1)',
      color: '#64748C',
    },
    a: {
      textDecoration: 'none',
      outline: 'none',
      fontWeight: 600,
    },
    li: {
      listStyle: 'none',
      textDecoration: 'none',
      outline: 'none',
    },
    button: {
      outline: 'none',
    },
  }),
};
